// Vercel Analytics only collects when the page is actually served by Vercel —
// its script lives at /_vercel/insights/script.js, which Vercel injects.
//
// This app ships to Firebase Hosting, whose catch-all rewrite answers that path
// with index.html. The browser then parses HTML as JavaScript and throws
// "Unexpected token '<'" on every page load, for analytics that could never
// report anyway. So only mount it where it can work.

/** True when this page is being served by Vercel. */
export function isVercelHosted(hostname = window?.location?.hostname || "") {
  if (process.env.REACT_APP_VERCEL_ANALYTICS === "true") return true;
  return hostname.endsWith(".vercel.app");
}
